import React from "react";

import { Box, useTheme } from "@mui/material";

interface Props {
  /**
   * Size of horizontal space.
   */
  x?: number;

  /**
   * Size of vertical space.
   */
  y?: number;

  /**
   * If the provided value in `h` or `v` is in pixel or a multiplier. Default is
   * false, `h` or `v` is a multiplier.
   */
  px?: boolean;

  /**
   * Size of the horizontal space in pixels.
   */
  pxHorizontal?: number;

  /**
   * Size of the horizontal space as a multiplier of the base spacing defined
   * in material-ui theme.
   */
  multiplierHorizontal?: number;

  /**
   * Size of the vertical space in pixels.
   */
  pxVertical?: number;

  /**
   * Size of the vertical space as a multiplier of the base spacing defined
   * in material-ui theme.
   */
  multiplierVertical?: number;
}

const Spacer: React.FC<Props> = ({
  pxHorizontal,
  pxVertical,
  multiplierHorizontal,
  multiplierVertical,
  x,
  y,
  px = false,
}) => {
  const theme = useTheme();
  const spacing = +theme.spacing();

  const verticalFromY = y ? (px ? y : spacing * y) : null;
  const horizontalFromX = x ? (px ? x : spacing * x) : null;

  const verticalSpace = pxVertical
    ? pxVertical
    : (multiplierVertical ?? 0) * spacing;
  const horizontalSpace = pxHorizontal
    ? pxHorizontal
    : (multiplierHorizontal ?? 0) * spacing;

  return (
    <Box
      minHeight={verticalFromY ?? verticalSpace}
      minWidth={horizontalFromX ?? horizontalSpace}
    />
  );
};

export default Spacer;
